import React, { useState, useEffect } from 'react';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ViewBeneficiary as BENE_SELECT } from 'Components/Api/MahagramDMTAPI';
import { LOGOUT } from 'ConstComponents';
import { DMTTransactionConfirmation } from 'Components/Alert/DMTTransactionConfirmation';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/MahagramDMTAPI';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import * as Yup from 'yup';
import {
    MONEY_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { useHistory } from 'react-router';
var mobile = '';

export default function BeneficiaryList({
    senderNo,
    ActiveDMTName,
    senderName,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const classes = commonStyle();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const history = useHistory();
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    mobile = senderNo;
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);
    const [status, setStatus] = useState('PROCESS');
    useEffect(() => {
        select();
        createColumns();
    }, [mobile]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);

        if (senderNo === undefined) return;

        if (senderNo === '') return;

        var beneReqObj = JSON.stringify({ Mobile: mobile });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setList(data);
    };

    const Transfer = async (request) => {
        let jsonObj = {
            Mobile: mobile,
            Name: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            Amount: request.Amount,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            BankID: request.SenderID
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        //if (formRef.current) formRef.current.handleSubmit();

        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setStatus(data.Status);
            setResponseAlert(data);
            setIsResponseAlertOpen(true);
            select();
            return;
        }
        setStatus(data.Status);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        select();
    };

    const VerifyOTP = async (values) => {
        var paramSender = {
            Mobile: mobile,
            AccountNo: values[3]
        };
        history.push('/MG_BeneGetOTP', paramSender);
        return;
    };

    const Verify = async (values) => {
        var jsonObj = {
            BeneficiaryID: values.BeneficiaryID,
            Name: values.BeniName,
            SenderName: senderName,
            BankName: values.BankName,
            AccountNo: values.AccountNumber,
            IFSC: values.IFSC,
            SenderID: values.SenderID,
            Mobile: mobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: values.RechargePin,
            BankID: values.SenderID
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            select();
            return;
        }

        var param = {
            Mobile: senderNo,
            AccountNo: values.AccountNumber
        };

        history.push('/MG_BeneficiaryVerify', param);
    };

    const MTTransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount'),
        RechargePin: Yup.string().when(['IsPin'], {
            is: (isPin) => isPin === 'true',

            then: Yup.string().required('Please enter pin')
        })
    });

    const MTTransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[9];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[8];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: values[5],
            RechargePin: RechargePin,
            SenderID: SenderID,
            BankID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
            ServiceID: MONEY_TRANSFER_CODE
        };
        setIsError(false);

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);

            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[9];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[8];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            BankID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
            ServiceID: MONEY_TRANSFER_CODE
        };

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            editableWithNumberOnly: true,
            length: 6
        });

        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }
        columns.push({
            label: 'OTP Verified',
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyOTP(values);
            }
        });

        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                MTTransferConfirmation(value);
            }
        });

        columns.push({
            label: 'SenderID',
            name: 'SenderID',
            hide: true
        });

        setMainColumns(columns);
    };

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiaries</h2>

            <ReactTable data={list} columns={mainColumns} />

            {isAlertOpen ? (
                <DMTTransactionConfirmation
                    isOpen={isAlertOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_TRANSFER_CODE
                        ) {
                            Transfer(request);
                        }

                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_VERIFY_CODE
                        ) {
                            Verify(request);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        select();
                    }}
                />
            ) : null}
            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </>
    );
}
